import { ListItem, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Repeat } from "lib/@components/repeat"
import { TailoredValue } from "routes/asset-register/plugins/general-tailoring/tailored-value"
import Iconify from "minimals-template/components/Iconify"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { If } from "lib/@components/switch"
import { createSlot } from "lib/@components/slot/create-slot"
import { Bound } from "lib/@components/binding/Bound"

export const ChangedTaskWrapper = createSlot("ChangedTaskWrapper")
export const ChangedTaskEnd = createSlot("ChangedTaskEnd")
export const ChangedTaskBelow = createSlot("ChangedTaskBelow")

export function ChangedTask({
    item: { title, classification, updatedClassification, originalValues, tailoredValues, originalTaskId },
    last,
}) {
    const tailored = Object.entries(tailoredValues)
        .filter(([t, v]) => v !== null && !t.startsWith("_"))
        .map("0")

    return (
        <Bound
            originalTaskId={originalTaskId}
            originalValues={originalValues}
            tailoredValues={tailoredValues}
            title={title}
        >
            <ChangedTaskWrapper.Wrapper>
                <ListItem data-cy="changed-task-item" sx={{ px: 0 }} divider={!last}>
                    <Stack sx={{ flex: 1 }}>
                        <ListItemBox>
                            <ListItemBox spacing={1} sx={{ flexWrap: "wrap" }}>
                                <If
                                    truthy={updatedClassification}
                                    then={
                                        <Iconify
                                            icon={ICON_FROM_CLASSIFICATION[updatedClassification]}
                                            sx={{ color: COLOR_FROM_CLASSIFICATION[updatedClassification] }}
                                            data-cy={`classification-${updatedClassification?.toLowerCase()}-updated`}
                                        />
                                    }
                                    else={
                                        <Iconify
                                            icon={ICON_FROM_CLASSIFICATION[classification]}
                                            sx={{ color: COLOR_FROM_CLASSIFICATION[classification] }}
                                            data-cy={`classification-${classification?.toLowerCase()}-current`}
                                        />
                                    }
                                />

                                <Typography variant="body2" sx={{ pr: 1 }}>
                                    {title}
                                </Typography>
                                <Repeat
                                    list={tailored}
                                    item={<TailoredValue original={originalValues} tailored={tailoredValues} />}
                                />
                            </ListItemBox>
                            <Stack direction="row">
                                <ChangedTaskEnd.Slot />
                            </Stack>
                        </ListItemBox>
                        <ChangedTaskBelow.Slot />
                    </Stack>
                </ListItem>
            </ChangedTaskWrapper.Wrapper>
        </Bound>
    )
}
